<template>
    <div>
        <el-form :inline="true" :model="query" class="query-form" size="small">
            <el-form-item>
                <el-date-picker v-model="servetime" type="datetimerange" :picker-options="pickerOptions"
                    range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" align="left"
                    format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                    :default-time="['00:00:00', '23:59:59']" @change="dateChange"></el-date-picker>
            </el-form-item>

            <el-form-item class="query-form-item">
                <el-input placeholder="订单号" v-model="query.orderNo" prefix-icon="el-icon-search"
                    @keyup.enter.native="onSubmit" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-refresh" @click="onRest"></el-button>
                <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
                <el-button type="primary" icon="el-icon-download" size="small" @click="exportExcel()">导出</el-button>
            </el-form-item>
        </el-form>
        <el-form style="display: flex;flex-direction: row-reverse;">
            <el-form-item>
                <el-button type="primary" icon="el-icon-edit" @click.native="handleInput(1,0)">添加订单</el-button>
            </el-form-item>
        </el-form>
        <el-table ref="multipleTable" v-loading="loading" :data="list"
            :header-cell-style="{ background: '#F4F4F5', color: '#606266' }" @selection-change="handleSelectionChange"
            border>
            <el-table-column label="订单号" align="center" prop="orderNo" />
            <el-table-column label="操作人" align="center" prop="authAdmin.username" />
            <el-table-column label="客户邮箱" align="center" prop="mbUser.useremail" />
            <el-table-column label="交货时间" align="center" prop="appTime" />
            <el-table-column label="商品金额" align="center" prop="goodsValue" />


            <el-table-column label="备注" align="center" prop="note" :show-overflow-tooltip="true" />
            <el-table-column width="300" label="操作" align="center">
              <!-- @click.native="handleInfo(scope.$index, scope.row)" -->
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click.native="handleInput(2,scope.row.id)">查看
                    </el-button>
                    <el-button v-if="scope.row.commited == 1" :type="scope.row.xmlUrl?'primary':'warning'" size="mini"
                        @click.native="downloadXML(scope.row)">生成报文
                    </el-button>
                </template>
            </el-table-column>

        </el-table>
        <el-pagination class="pagination-container" background :current-page="query.currentPage"
            :page-size="query.pageSize" @size-change="handleSizeChange" @current-change="handleCurrentChange"
            layout="total,sizes,prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50]" :total="totalNumber">
        </el-pagination>

        <!--  查看 --->
        <el-dialog :visible.sync="formInfo" :before-close="hideInfo" width="1200px" top="5vh" v-dialogDrag
            title="售后工单处理/详情">
            <el-form :model="orderWork">
                <h2>申请信息:</h2>
                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px"
                    v-if="orderWork.mbOrderWork == null ">
                    <el-form-item label="申请时间:" style="width:50%;display: inline-block;margin-left:0px;">
                        <input v-if="this.orderWork.mbOrderWork !=null" :value="
                orderWork.mbOrderWork.orderworktime
                  | formatDateStr('yyyy-MM-dd')
              " type="text" readonly>
                    </el-form-item>
                    <el-form-item label="联系人:" style="width:30%;display: inline-block"
                        v-if="orderWork.mbOrderWork != null ">
                        <input :value="orderWork.mbOrderWork.orderworkname" type="text" readonly>
                    </el-form-item>
                </el-form-item>
                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px"
                    v-if="orderWork.mbOrderWork != null ">
                    <el-form-item label="联系电话:">
                        <input :value="orderWork.mbOrderWork.userMobile" readonly>
                    </el-form-item>
                </el-form-item>
                <el-form-item label="详情描述:" style="width:100%;display: inline-block;margin-left:0px;"
                    v-if="orderWork.mbOrderWork != null ">
                    <br>
                    <div v-html="orderWork.mbOrderWork.orderworkdetail"></div>
                    <el-button v-if="orderWork.mbOrderWork.orderworkstatus == 0" type="primary" size="mini"
                        @click.native="handle(orderWork.mbOrderWork)">处理
                    </el-button>
                </el-form-item>
                <br>

                <h2 v-if="orderWork.mbOrderVO != null">订单信息:</h2>

                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px"
                    v-if="orderWork.mbOrderVO != null">
                    <el-form-item label="下单时间:" style="width:50%;display: inline-block"
                        v-if="orderWork.mbOrderVO != null ">
                        <span v-if="orderWork.mbOrderVO.ordertime == null  ">无</span>
                        <span v-if="orderWork.mbOrderVO != null && orderWork.mbOrderVO.ordertime != null  ">
                            {{
                                orderWork.mbOrderVO.ordertime
                                    | formatDateStr("yyyy-MM-dd hh:mm:ss")
                            }}
                        </span>
                    </el-form-item>
                    <el-form-item label="付款时间:" style="width:30%;display: inline-block;margin-left:0px;"
                        v-if="orderWork.mbOrderVO != null">
                        <span v-if="orderWork.mbOrderVO.orderpaytime == null">无</span>
                        <span v-if="orderWork.mbOrderVO.orderpaytime != null">
                            {{
                                orderWork.mbOrderVO.orderpaytime
                                    | formatDateStr("yyyy-MM-dd hh:mm:ss")
                            }}
                        </span>
                    </el-form-item>
                </el-form-item>

                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px"
                    v-if="orderWork.mbOrderVO != null">
                    <el-form-item label="排产时间:" style="width:50%;display: inline-block">
                        <span v-if="orderWork.mbOrderVO.orderschedulingtime == null">无</span>
                        <span v-if="orderWork.mbOrderVO.orderschedulingtime != null">
                            {{
                                orderWork.mbOrderVO.orderschedulingtime
                                    | formatDateStr("yyyy-MM-dd hh:mm:ss")
                            }}
                        </span>
                    </el-form-item>
                    <el-form-item label="生产时间:" style="width:30%;display: inline-block;margin-left:0px;"
                        v-if="orderWork.mbOrderVO != null">
                        <span v-if="orderWork.mbOrderVO.orderprodutime == null">无</span>
                        <span v-if="orderWork.mbOrderVO.orderprodutime != null">
                            {{
                                orderWork.mbOrderVO.orderprodutime
                                    | formatDateStr("yyyy-MM-dd hh:mm:ss")
                            }}
                        </span>
                    </el-form-item>
                </el-form-item>

                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px"
                    v-if="orderWork.mbOrderVO != null">
                    <el-form-item label="包装时间:" style="width:50%;display: inline-block">
                        <span v-if="orderWork.mbOrderVO.orderpacktime == null">无</span>
                        <span v-if="orderWork.mbOrderVO.orderpacktime != null">
                            {{
                                orderWork.mbOrderVO.orderpacktime
                                    | formatDateStr("yyyy-MM-dd hh:mm:ss")
                            }}
                        </span>
                    </el-form-item>
                    <el-form-item label="发货时间:" style="width:50%;display: inline-block;margin-left:0px;"
                        v-if="orderWork.mbOrderVO != null">
                        <span v-if="orderWork.mbOrderVO.orderdevlitime == null">无</span>
                        <span v-if="orderWork.mbOrderVO.orderdevlitime != null">
                            {{
                                orderWork.mbOrderVO.orderdevlitime
                                    | formatDateStr("yyyy-MM-dd hh:mm:ss")
                            }}
                        </span>
                    </el-form-item>
                </el-form-item>

                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px"
                    v-if="orderWork.mbOrderVO != null ">
                    <el-form-item label="收货时间:" style="width:50%;display: inline-block">
                        <span v-if="orderWork.mbOrderVO.ordertacktime == null">无</span>
                        <span v-if="orderWork.mbOrderVO.ordertacktime">
                            {{
                                orderWork.mbOrderVO.ordertacktime
                                    | formatDateStr("yyyy-MM-dd hh:mm:ss")
                            }}
                        </span>
                    </el-form-item>
                    <el-form-item label="发货仓:" style="width:40%;display: inline-block;margin-left:0px;"
                        v-if="orderWork.mbOrderVO != null">
                        <input v-if="orderWork.mbOrderVO.repertorysname == null" value="-" type="text" readonly>
                        <input v-if="orderWork.mbOrderVO.repertorysname != null"
                            :value="orderWork.mbOrderVO.repertorysname" type="text" readonly>
                    </el-form-item>
                </el-form-item>

                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px"
                    v-if="orderWork.mbOrderVO != null ">
                    <el-form-item label="订单编号:" style="width:50%;display: inline-block">
                        <input v-model="orderWork.mbOrderVO.systemtradeno" type="text" readonly>
                    </el-form-item>
                    <el-form-item label="订单状态:" style="width:30%;display: inline-block;margin-left:0px;"
                        v-if="orderWork.mbOrderVO != null">
                        <span v-if="orderWork.mbOrderVO.orderstatus == 0">待支付</span>
                        <span v-if="orderWork.mbOrderVO.orderstatus == 1">已排产</span>
                        <span v-if="orderWork.mbOrderVO.orderstatus == 2">生产中</span>
                        <span v-if="orderWork.mbOrderVO.orderstatus == 3">包装中</span>
                        <span v-if="orderWork.mbOrderVO.orderstatus == 4">待发货</span>
                        <span v-if="orderWork.mbOrderVO.orderstatus == 5">待收货</span>
                        <span v-if="orderWork.mbOrderVO.orderstatus == 6">已完成</span>
                        <span v-if="orderWork.mbOrderVO.orderstatus == 7">已取消</span>
                        <span v-if="orderWork.mbOrderVO.orderstatus == 8">已申请售后</span>
                        <span v-if="orderWork.mbOrderVO.orderotherstatus == 1">(账期额度已归还)</span>
                        &nbsp;&nbsp;
                        <el-button v-if="orderWork.mbOrderVO.orderstatus == 0" type="primary" size="mini"
                            @click.native="cancleOrder(orderWork.mbOrderVO)">取消订单
                        </el-button>&nbsp;&nbsp;
                        <el-button v-if="orderWork.mbOrderVO.orderstatus == 5 && orderWork.mbOrderVO != null"
                            type="primary" size="mini" v-show="orderWork.mbOrderVO.orderphysicaltype == 1"
                            @click.native="expressMessage(orderWork.mbOrderVO)">物流
                        </el-button>
                        <el-button v-if="orderWork.mbOrderVO.orderstatus == 5 && orderWork.mbOrderVO != null"
                            type="primary" size="mini" v-show="orderWork.mbOrderVO.orderphysicaltype == 2"
                            @click.native="expressMessage(orderWork.mbOrderVO)">物流
                        </el-button>
                    </el-form-item>
                </el-form-item>

                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px"
                    v-if="orderWork.mbOrderVO != null ">
                    <el-form-item label="快递方式:" style="width:50%;display: inline-block">
                        <!-- <span v-if="orderWork.mbOrderVO.orderfreight != null">{{
                          orderWork.mbOrderVO.expressname
                        }}</span>
                        <span v-else>自提</span>-->
                        <span v-if="orderWork.mbOrderVO.orderphysicaltype == 0">HFM物流</span>
                        <span v-if="orderWork.mbOrderVO.orderphysicaltype == 1">联邦快递</span>
                        <span v-if="orderWork.mbOrderVO.orderphysicaltype == 2">DHL物流</span>
                        <span v-if="orderWork.mbOrderVO.orderphysicaltype == 3">自提</span>
                        <span v-if="orderWork.mbOrderVO.orderphysicaltype == null">-</span>
                    </el-form-item>
                    <el-form-item label="运费:" style="width:30%;display: inline-block;margin-left:0px;"
                        v-if="orderWork.mbOrderVO != null">
                        <span>
                            ￥{{
                    orderWork.mbOrderVO.orderfreight
                        | price(orderWork.mbOrderVO.orderfreight)
                }}
                        </span>
                    </el-form-item>
                </el-form-item>

                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px">
                    <el-form-item label="实付金额:" style="width:50%;display: inline-block"
                        v-if="orderWork.mbOrderVO != null">
                        <span>
                            ${{
                    orderWork.mbOrderVO.ordertotalprice
                        | price(orderWork.mbOrderVO.ordertotalprice)
                }}
                        </span>
                    </el-form-item>
                    <el-form-item label="积分抵扣:" style="width:50%;display: inline-block;margin-left:0px;"
                        v-if="orderWork.mbOrderVO != null">
                        <!-- <input v-model="orderWork.mbOrderVO.orderintegral" type="text" readonly> -->
                        <span v-if="orderWork.mbOrderVO.playintegral==1">{{ orderWork.mbOrderVO.orderintegral }}</span>
                        <span v-if="orderWork.mbOrderVO.playintegral==0">未使用积分</span>
                    </el-form-item>
                </el-form-item>
                <el-form-item label="支付凭证:" style="width:30%;display: inline-block" v-if="orderWork.mbOrderVO != null">
                    <el-popover placement="right" trigger="hover">
                        <img :src="orderWork.mbOrderVO.playorder" style="width:400px;border-radius:3px;">
                        <img slot="reference" :src="orderWork.mbOrderVO.playorder"
                            style="max-height: 50px;max-width: 50px;border-radius:5px;">
                    </el-popover>
                </el-form-item>
                <el-table v-if="orderWork.mbOrderVO != null" ref="multipleTable" v-loading="loading"
                    :data="orderWork.mbOrderComVOList" :header-cell-style="{ background: '#F4F4F5', color: '#606266' }"
                    @selection-change="handleSelectionChange" border>
                    <el-table-column label="产品编码" align="center" prop="productnum" :show-overflow-tooltip="true" />
                    <el-table-column label="图片" prop="commodityurl" align="center" width="200">
                        <template slot-scope="scope">
                            <el-popover placement="right" trigger="hover">
                                <img :src="scope.row.commodityurl" style="width:400px;border-radius:3px;">
                                <img slot="reference" :src="scope.row.commodityurl"
                                    style="max-height: 50px;max-width: 50px;border-radius:5px;">
                            </el-popover>
                        </template>
                    </el-table-column>
                    <el-table-column label="商品名称" align="center" prop="commodityname" :show-overflow-tooltip="true" />
                    <el-table-column label="货期" prop="specsurvi" align="center" />
                    <el-table-column label="重量" prop="speclweight" align="center" />
                    <el-table-column label="材质规格" align="center" prop="specstands" />
                    <el-table-column label="单价" align="center" prop="commodityprice" />
                    <el-table-column label="数量" align="center" prop="commoditynum" />
                    <el-table-column label="单品合计" align="center" prop="totalprice" />
                </el-table>
                <el-form-item label="留言:" v-if="orderWork.mbOrderVO != null">
                    <input v-model="orderWork.mbOrderVO.orderleave" type="text" readonly>
                </el-form-item>

                <h2 v-if="orderWork.mbOrderVO != null">买家信息:</h2>
                <br>
                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px"
                    v-if="orderWork.mbOrderVO != null">
                    <el-form-item label="用户邮箱:" style="width:50%;display: inline-block">
                        <input v-if="orderWork.mbUserAddressVO != null" :value="orderWork.mbUserAddressVO.useremail"
                            type="text" readonly>
                        <input v-if="orderWork.mbUserAddressVO == null" value="-" type="text" readonly>
                    </el-form-item>

                    <el-form-item label="取货方式:" style="width:30%;display: inline-block"
                        v-if="orderWork.mbOrderVO != null">
                        <input v-if="orderWork.mbOrderVO.orderphysicaltype == null" value="-">
                        <input v-if="orderWork.mbOrderVO.orderphysicaltype == 0" value="HFM物流">
                        <input v-if="orderWork.mbOrderVO.orderphysicaltype == 1" value="联邦快递">
                        <input v-if="orderWork.mbOrderVO.orderphysicaltype == 2" value="DHL物流">
                        <input v-if="orderWork.mbOrderVO.orderphysicaltype == 3" value="自提">
                    </el-form-item>
                </el-form-item>
                <el-form-item style="border-bottom:1px solid #ebeef5;" label-width="0px"
                    v-if="orderWork.mbOrderVO != null">
                    <el-form-item label="收货人:" style="width:50%;display: inline-block">
                        <input v-if="orderWork.mbUserAddressVO != null"
                            :value="orderWork.mbUserAddressVO.useraddressname" type="text" readonly>
                        <input v-if="orderWork.mbUserAddressVO == null" value="-" type="text" readonly>
                    </el-form-item>
                    <el-form-item label="联系方式:" style="width:30%;display: inline-block">
                        <input v-if="orderWork.mbUserAddressVO != null"
                            :value="orderWork.mbUserAddressVO.useraddressphone" type="text" readonly>
                        <input v-if="orderWork.mbUserAddressVO == null" value="-" type="text" readonly>
                    </el-form-item>
                </el-form-item>
                <el-form-item label="收货地址:" v-if="orderWork.mbOrderVO != null">
                    <input v-if="orderWork.mbUserAddressVO != null" :value="orderWork.mbUserAddressVO.useraddress"
                        type="text" readonly>
                    <input v-if="orderWork.mbUserAddressVO == null" value="-" type="text" readonly>
                </el-form-item>
            </el-form>
        </el-dialog>
        <!-- 物流弹窗 -->
        <el-dialog title="物流信息" :visible.sync="formExpress" :before-close="hideExpress" width="800px" top="5vh"
            v-dialogDrag>
            <el-form :model="this.expressInfo">
                <el-form-item label="快递公司:">
                    <div v-if="this.expressInfo.trackingName != null" v-html="this.expressInfo.trackingName" readonly />
                </el-form-item>
                <el-form-item label="快递单号:">
                    <div v-if="this.expressInfo.trackingNumber != null && orderWork.mbOrderVO != null "
                        v-html="this.expressInfo.trackingNumber" readonly />
                </el-form-item>
                <el-form-item label="快件跟踪：" />
                <div class="block">
                    <el-timeline>
                        <el-timeline-item v-for="(items, index) in this.expressInfo.events" :key="index"
                            icon="el-icon-more" color="#0bbd87">
                            <span v-if="items.address.city!=null">
                                {{
                      items.address.countryCode +
                      ' ' +
                      items.address.city +
                      ' ' +
                      items.eventDescription
                  }}
                            </span>
                            <span v-else>{{ items.eventDescription }}</span>
                            <!-- {{items.eventDescription}} -->

                            <!-- {{ items.address.countryCode +
                              ' ' +
                              items.address.city +
                              '   ' +
                            items.eventDescription}}-->
                            <br>
                            <br>
                            {{ items.timestamp |formatDateStr("yyyy-MM-dd hh:mm:ss") }}
                        </el-timeline-item>
                    </el-timeline>
                </div>
            </el-form>
        </el-dialog>

        <el-dialog title="物流信息" :visible.sync="formExpresss" :before-close="hideExpresss" width="800px" top="5vh"
            v-dialogDrag>
            <el-form :model="this.expressInfos">
                <el-form-item label="快递公司:">
                    <input :value="'DHL'" readonly>
                </el-form-item>
                <el-form-item label="快递单号:">
                    <input v-if="this.expressInfos.awbnumber != null" :value="this.expressInfos.awbnumber" readonly>
                </el-form-item>
                <el-form-item label="快件跟踪：" />
                <div class="block">
                    <el-timeline :reverse="'false'">
                        <el-timeline-item v-for="(items, index) in this.expressInfos.shipmentInfo.shipmentEvent
            .logistics" :key="index" icon="el-icon-more" color="#0bbd87" :timestamp="items.date + ' ' + items.time">
                            {{ items.serviceEvent.description }}
                        </el-timeline-item>
                    </el-timeline>
                </div>
            </el-form>
        </el-dialog>
        <!--  物流 --->
        <!-- <el-dialog
          title="物流信息"
          :visible.sync="formExpress"
          :before-close="hideExpress"
          width="800px"
          top="5vh"
          v-dialogDrag
        >
          <el-form :model="this.expressInfo">
            <el-form-item label="快递公司:">
              <div
                v-if="this.expressInfo.trackingName != null"
                v-html="this.expressInfo.trackingName"
                readonly
              />
            </el-form-item>
            <el-form-item label="快递单号:">
              <div
                v-if="this.expressInfo.trackingNumber != null"
                v-html="this.expressInfo.trackingNumber"
                readonly
              />
            </el-form-item>
            <el-form-item label="快件跟踪："/>
            <input
              v-if="this.expressInfo.events == null"
              value="Please contact specific customer service specialist for instant logistics status"
              style="width:100%"
            >
            <div v-for="(items, index) in this.expressInfo.events" :key="index">
              <input :value="'第' + [index + 1] + '条:'">
              <br>
              <br>

              <div
                v-html="
                  items.address.countryCode +
                    ' ' +
                    items.address.city +
                    '   ' +
                    items.eventDescription
                "
                readonly
              />
              <el-form-item>
                <span>{{ items.timestamp | formatDateStr("yyyy-MM-dd hh:mm:ss") }}</span>
              </el-form-item>
            </div>
          </el-form>
        </el-dialog>-->

        <!-- <el-dialog
          title="物流信息"
          :visible.sync="formExpresss"
          :before-close="hideExpresss"
          width="800px"
          top="5vh"
          v-dialogDrag
        >
          <el-form :model="this.expressInfos">
            <el-form-item label="快递公司:">
              <input
                v-if="this.expressInfos.shipmentInfo.shipperName != null"
                :value="this.expressInfos.shipmentInfo.shipperName"
                readonly
              >
            </el-form-item>
            <el-form-item label="快递单号:">
              <input
                v-if="this.expressInfos.shipmentInfo.shipperAccountNumber != null"
                :value="this.expressInfos.shipmentInfo.shipperAccountNumber"
                readonly
              >
            </el-form-item>
            <el-form-item label="快件跟踪："/>
            <div
              v-for="(items, index) in this.expressInfos.shipmentInfo.shipmentEvent
                .logistics"
              :key="index"
            >
              <input :value="'第' + [index + 1] + '条:'">
              <br>
              <br>
              <input
                :value="
                  items.serviceArea.description +
                    ' ' +
                    items.serviceArea.serviceAreaCode
                "
                readonly
              >
              <el-form-item>
                <input :value="items.date + ' ' + items.time">
              </el-form-item>
            </div>
          </el-form>
        </el-dialog>-->
        <!--处理-->
        <el-dialog :visible.sync="formVisible" :before-close="hideFormUpdate" width="800px" top="5vh" v-dialogDrag>
            <el-form :model="formTest" :rules="formRules" ref="updateDataForm">
                <el-form-item label="回复" prop="orderworktext">
                    <textarea v-model="formTest.orderworktext" style="width: 380px;height: 180px;" clearable></textarea>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="hideForm">取消</el-button>
                <el-button type="primary" @click.native="formSubmit()" :loading="formLoading">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        getList,
        genStub,
        handle,
        getOrderWorkInfo
    } from "../../api/order/otherOrder.js";
    // import { formatDateStr } from "../../filtres/index";
    import {
        BASE_URL
    } from "../../config/app";
    import {
        cancleOrder
    } from "../../api/order/saleOrder.js";
    import {
        getfontwb,
        getfontdhl
    } from "../../api/order/saleOrder.js";
    import {
        getAdminId
    } from "@/utils/auth";

    export default {
        data() {
            return {
                orderworktime: "",
                pickerOptions1: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                pickerOptions: {
                    shortcuts: [{
                            text: "最近一周",
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(
                                    start.getTime() - 3600 * 1000 * 24 * 7
                                );
                                picker.$emit("pick", [start, end]);
                            }
                        },
                        {
                            text: "最近一个月",
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(
                                    start.getTime() - 3600 * 1000 * 24 * 30
                                );
                                picker.$emit("pick", [start, end]);
                            }
                        },
                        {
                            text: "最近三个月",
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(
                                    start.getTime() - 3600 * 1000 * 24 * 90
                                );
                                picker.$emit("pick", [start, end]);
                            }
                        },
                        {
                            text: "最近六个月",
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(
                                    start.getTime() - 3600 * 1000 * 24 * 180
                                );
                                picker.$emit("pick", [start, end]);
                            }
                        }
                    ]
                },
                cancelToggle: false,
                servetime: [],
                pushtime: "",
                query: {
                    orderNo: "",
                    startTime: "",
                    endTime: "",
                    currentPage: 1,
                    pageSize: 10
                },
                list: [],
                formExpress: false,
                formExpresss: false,
                orderWork: {
                    mbOrderWork: {
                        orderworktime: "",
                        orderworkname: "",
                        orderworkphone: "",
                        orderworkdetail: ""
                    },
                    mbOrderVO: {
                        ordertime: "",
                        orderpaytime: "",
                        orderschedulingtime: "",
                        orderprodutime: "",
                        orderpacktime: "",
                        orderdevlitime: "",
                        ordertacktime: "",
                        repertorysname: "",
                        systemtradeno: "",
                        orderfreight: "",
                        ordertotalprice: "",
                        orderintegral: "",
                        specsurvi: "",
                        orderleave: "",
                        expressname: "",
                        orderstatus: ""
                    },
                    mbOrderComVOList: [],
                    mbUserAddressVO: {
                        usernick: "",
                        useraddressname: "",
                        useraddressphone: "",
                        useraddress: ""
                    }
                },
                expressInfo: {},
                expressInfos: {
                    shipmentInfo: {
                        shipperName: "",
                        shipperAccountNumber: "",
                        shipper: {
                            countryCode: "",
                            city: ""
                        },
                        consignee: {
                            countryCode: "",
                            city: ""
                        },
                        shipmentEvent: {
                            logistics: [{
                                serviceEvent: {
                                    description: "",
                                    serviceAreaCode: ""
                                },
                                data: "",
                                time: ""
                            }]
                        }
                    }
                },
                totalNumber: 0,
                loading: true,
                index: null,
                formName: null,
                formLoading: false,
                formInfo: false,
                formVisible: false,
                formRules: {
                    orderworktext: [{
                        required: true,
                        message: "请输入回复内容",
                        trigger: "change"
                    }]
                },
                formTest: {
                    orderworktext: "",
                    orderNo: ""
                },
                multipleSelection: [] //多选集合
            };
        },
        methods: {
            handleInput(type,otherorderId) {
                this.$router.push({
                    path: '/order/otherOrderForm',
                    query: {
                      type: type,
                      otherorderId:otherorderId
                    }
                })
            },
            dateChange(val) {
                if (val == null) {
                    this.query.startTime = "";
                    this.query.endTime = "";
                } else {
                    this.query.startTime = val[0];
                    this.query.endTime = val[1];
                }
                this.getList();
            },
            toggleSelection(rows) {
                if (rows) {
                    rows.forEach(row => {
                        this.$refs.multipleTable.toggleRowSelection(row);
                    });
                } else {
                    this.$refs.multipleTable.clearSelection();
                }
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
                if (val == "") {
                    this.cancelToggle = false;
                    return;
                }
                this.cancelToggle = true;
            },
            delGroup() {
                var ids = this.multipleSelection.map(item => item.serveid).join(); //获取所有选中行的id组成的字符串，以逗号分隔

                if (ids == "") {
                    this.$message({
                        message: "请先选择",
                        type: "warning"
                    });
                    return;
                }
                this.handleDel(ids);
            },
            onRest() {
                this.query = {
                    currentPage: 1,
                    pageSize: 10
                };
                this.servetime = [];
                this.getList();
            },
            //隐藏物流信息
            hideExpress() {
                this.formExpress = !this.formExpress;
            },
            hideExpresss() {
                this.formExpresss = !this.formExpresss;
            },
            hideInfo() {
                // 更改值
                this.formInfo = !this.formInfo;
                // 清空表单
                return true;
            },
            onSubmit() {
                this.$router.push({
                    path: "",
                    query: this.query
                });
                this.getList();
            },
            handleCurrentChange(val) {
                this.query.currentPage = val;
                //scrollTo(0, 800);
                this.getList();
            },
            handleSizeChange(val) {
                this.query.pageSize = val;
                this.getList();
            },

            /*  this.query = {
                  currentPage: 1,
                  pageSize: 10
              };
               this.servetime = [];*/

            getList() {
                this.loading = true;
                getList(this.query)
                    .then(response => {
                        if (response.code) {
                            this.$message.error(response.message);
                        }
                        console.log('responseData=', response.data);
                        this.list = response.data.list || [];
                        this.totalNumber = response.data.totalNumber || 0;
                        setTimeout(() => {
                            this.loading = false;
                        }, 0.3 * 1000);
                    })
                    .catch(() => {
                        this.loading = false;
                        this.list = [];
                        this.totalNumber = 0;
                    });
            },
            handleInfo(index, row) {
                this.loading = true;
                this.orderWork = "";
                this.query.orderNo = row.orderNo;
                getOrderWorkInfo(this.query)
                    .then(response => {
                        if (response.code) {
                            this.$message.error(response.message);
                        }
                        this.orderWork = response.data || [];
                        this.query.orderNo = "";
                        this.formInfo = true;
                        this.loading = false;
                        setTimeout(() => {
                            this.loading = false;
                        }, 0.3 * 1000);
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            },
            hideForm() {
                // 更改值
                this.formVisible = !this.formVisible;
                this.formTest.orderNo = "";
                this.formTest.orderworktext = "";
                return true;
            },
            hideFormUpdate() {
                // 更改值
                this.formVisible = !this.formVisible;
                this.formTest.orderNo = "";
                this.formTest.orderworktext = "";
                return true;
            },
            //取消订单
            cancleOrder(row) {
                this.query.orderid = row.orderid;
                cancleOrder(this.query)
                    .then(response => {
                        if (response.code) {
                            this.$message.error(response.message);
                        }
                        this.$message.success("操作成功");
                        // 刷新数据
                        //this.list.splice(index, 1);
                        this.formInfo = false;
                        setTimeout(() => {
                            this.loading = false;
                        }, 0.3 * 1000);
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            },
            expressMessage(row) {
                this.loading = true;
                let params = new URLSearchParams();
                params.append("trackingnumber", row.expressnum);
                if (row.orderphysicaltype == 1) {
                    getfontwb(params)
                        .then(res => {
                            this.expressInfo = res.data;
                            this.loading = false;
                            this.formExpress = true;
                        })
                        .catch(() => {});
                } else {
                    getfontdhl(params)
                        .then(res => {
                            this.expressInfos = res.data;
                            this.loading = false;
                            this.formExpresss = true;
                        })
                        .catch(() => {});
                }
            },
            // 处理页面
            handle(row) {
                this.formVisible = true;
                this.formTest.orderNo = row.orderNo;
            }, // 下载文档
            downloadXML(row) {
                // 如果有值，直接下载
                let that = this;
                that.loading = true;
                if (row.xmlUrl) {
                    // this.$message({
                    //     message: '开始下载',
                    //     type: 'success'
                    // });
                    window.location.href = row.xmlUrl;
                    that.loading = false;
                } else {
                    // 如果没有值，先生成再下载

                    let param = {};
                    param.otherorderId = row.id;
                    genStub(param).then(response => {
                        that.loading = false;
                        console.log("response=", response);
                        if (response.code) {
                            this.$message.error(response.message);
                        } else {
                            window.location.href = response.data;
                            that.loading = false;
                            this.getList();
                        }

                    })
                }


            },
            formSubmit() {
                this.loading = true;
                handle(this.formTest)
                    .then(response => {
                        if (response.code) {
                            this.$message.error(response.message);
                        }
                        this.$message.success("操作成功");
                        // 刷新数据
                        //this.list.splice(index, 1);
                        this.formVisible = false;
                        this.getList();
                        setTimeout(() => {
                            this.loading = false;
                        }, 0.3 * 1000);
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            },
            //导出
            exportExcel() {

                // query      orderNo: "",
                //           startTime: "",
                //           endTime: "",

                let query = this.query;
                window.location.href = BASE_URL + "/otherorder/export?orderNo=" + query.orderNo + "&startTime=" + query
                    .startTime + "&endTime=" + query.endTime;
            }
        },
        filters: {
            price: function (myInput) {
                if (myInput != null) {
                    var val = parseInt(myInput);
                    if (typeof val === "number") {
                        return parseFloat(myInput).toFixed(2);
                    }
                } else {
                    return "-";
                }
            }
        },
        created() {
            // 将参数拷贝进查询对象
            let query = this.$route.query;
            // console.log('xxxx');
            this.adminId = getAdminId();
            console.log('adminid=', this.adminId);
            this.query = Object.assign(this.query, query);
            this.query.pageSize = parseInt(this.query.pageSize);
            // 加载表格数据
            this.getList();
        }
    };

</script>

<style type="text/scss" lang="scss">
    body {
    margin: 0;
}
</style>
